import React from 'react'
import "./About.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";
import { MdStars } from "react-icons/md";
import Data from '../Data/Data';


const About = () => {
    return (
        <div className='about-main' id='about'>
            <div className="about-container">
                <div className="about-left">

                    <img src={Data.founder} alt="" />

                </div>

                <div className="about-right">
                    {/* <div className="about-top">
                        <span><TfiLayoutLineSolid />About Profi1 Station</span>
                    </div> */}
                    {/* // <div className="about-text">
                    //     <span>Profi1 Station was built on a simple idea — that good financial advice shouldn't require a trip to Mumbai or a call-centre queue.</span>

                    //     <p>As an authorized Business Associate of Motilal Oswal, we bring institutional-grade research, execution, and compliance to a desk you can actually walk into. Every client works directly with an advisor who knows their portfolio, their goals, and their risk appetite — not a rotating support line.</p>

                    //     <p>Our work spans first-time demat accounts to ongoing portfolio management, always anchored in the same principle: wealth creation should be transparent, personal, and built for the long term.</p>
                    // </div> */}
                    <div className="about-founder">
                        <span><TfiLayoutLineSolid />Founder & Lead Advisor, Profi1 Station</span>
                    </div>

                    <div className="about-founder-brief">
                        <div className="about-f1">
                            <p>Manoj Palta has been building his career in financial services since 2012, with over a decade of hands-on experience guiding investors through every market cycle. Having completed his qualifications through local institutions in Patiala, he brings a deep, ground-level understanding of the region's investors — their goals, their concerns, and the kind of guidance that actually helps them make confident financial decisions.</p>
                        </div>
                        <div className="about-f2">
                            <p>That foundation, paired with the backing of Motilal Oswal Financial Services, shaped the vision behind Profi1 Station: bring institutional-grade research and advisory support to Patiala, delivered the way a local partner should — personally, transparently, and with a long-term relationship in mind rather than a one-time transaction.</p>
                        </div>
                        <div className="about-f3">
                            <span>Today, that same philosophy continues to guide Manoj's approach with every client who walks through the doors of Profi1 Station.</span>
                        </div>
                    </div>

                    <div className="about-qualification">
                        <span><TfiLayoutLineSolid />Founder - Qualifications</span>

                        <div className="about-study">
                            <span><MdStars /> NISM-Series-VIII: Equity Derivatives Certification Examination
                            </span>
                            <span><MdStars /> ⁠NISM-Series-XVI: Commodity Derivatives Certification Examination
                            </span>
                            <span><MdStars /> ⁠NISM-Series-I: Currency Derivatives Certification Examination
                            </span>
                            <span><MdStars /> ⁠NISM-Series-V-A: Mutual Fund Distributors Certification Examination
                            </span>
                            <span><MdStars />NISM-Series-VI: Depository Operations Certification Examination
                            </span>
                            <span>
                                <MdStars />NISM-Series-VII: Securities Operations and Risk Management (SORM) Certification Examination

                            </span>
                            <span>
                                <MdStars />⁠NISM-Series-XV: Research Analyst Certification Examination

                            </span>
                        </div>
                    </div>

                </div>
            </div>
            
        </div>
    )
}

export default About